import { render, staticRenderFns } from "./ReglamentoView.vue?vue&type=template&id=55045a7e&scoped=true"
import script from "./ReglamentoView.vue?vue&type=script&lang=js"
export * from "./ReglamentoView.vue?vue&type=script&lang=js"
import style0 from "./ReglamentoView.vue?vue&type=style&index=0&id=55045a7e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55045a7e",
  null
  
)

export default component.exports